/* global _appConstants */
import React, { useEffect, createRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Drawer } from "@material-ui/core";
import jwt from "jwt-decode";
import { ListMenuNav } from "./components";
import { OAuth as OAuthActions } from "../../../../js/actions";
import TokenStorage from "../../../../js/utils/tokenStorage";

const drawerWidth = "240px";
const drawerCollapsedWidth = "65px";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  menuButton: {
    marginRight: theme.spacing(3) + 1,
  },
  hide: {
    display: "none",
  },
  drawer: {
    whiteSpace: "nowrap",
    height: "100%",
    position: "absolute",
    top: 0,
    [theme.breakpoints.down("xs")]: {
      top: "63px",
      height: "calc(100vh - 63px)",
    },
    [theme.breakpoints.up("sm")]: {
      top: "71px",
      height: "calc(100vh - 71px)",
    },
    [theme.breakpoints.up("md")]: {
      top: "77px",
      height: "calc(100vh - 77px)",
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: drawerCollapsedWidth,
    [theme.breakpoints.up("sm")]: {
      width: drawerCollapsedWidth,
    },
  },
}));

// Custom hook to prepare feature-based menu
const usePrepareFeatureBasedMenu = (userRole, menuList) => {
  const token = TokenStorage.getToken();
  const tokenDetails = jwt(token);
  let sidebarOptions = [];

  _appConstants.menuOptions.forEach((element, index) => {
    if (index === 0) {
      sidebarOptions.push(element);
    } else if (tokenDetails.authorities.includes(element.role)) {
      sidebarOptions.push(element);
    }
  });

  return sidebarOptions;
};

const Sidebar = (props) => {
  const { open, ...rest } = props;
  const classes = useStyles();
  const sidebarRef = createRef();
  const userRole = useSelector((state) => state?.OAuth?.authData?.role || "N/A");
  const dispatch = useDispatch();

  const sidebarOptions = usePrepareFeatureBasedMenu(userRole, _appConstants.menuOptions);

  useEffect(() => {
    let activeIndex = _appConstants.menuOptions.findIndex(
      (item) => window.location.href.indexOf(item.href) > 0
    );
    const token = TokenStorage.getToken();
    const tokenDetails = jwt(token);
    let sidebarOptions = [];
    _appConstants.menuOptions.forEach((element, index) => {
      if (tokenDetails.authorities.includes(element.role)) {
        sidebarOptions.push(element);
      }
    });
    if (sidebarOptions.length === 2) {
      activeIndex = activeIndex === 7 ? 1 : (activeIndex === 8 ? 2 : activeIndex);
    }
    if (activeIndex > -1) dispatch(OAuthActions.ClickHandler(activeIndex));
  }, [dispatch]);

  return (
    <Drawer
      ref={sidebarRef}
      anchor="left"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      open
      variant="persistent"
      PaperProps={{
        style: {
          position: "absolute",
          background:
            "linear-gradient(180deg, rgba(30, 41, 59, 0.98) 0%, rgba(37, 54, 95, 0.98) 48%, rgba(51, 65, 85, 0.98) 100%)",
          borderRight: "1px solid rgba(29, 78, 216, 0.16)",
          boxShadow: "inset -1px 0 0 rgba(255, 255, 255, 0.04)",
          overflowX: "hidden",
          overflowY: "hidden",
        },
      }}
    >
      <ListMenuNav
        {...rest}
        isOpen={open}
        className={clsx(classes.drawer)}
        pages={sidebarOptions}
      />
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
};

export default React.memo(Sidebar);
